import React from "react";
import { TimerContext } from "../TimerContext";

export function useCountdownTimer() {
  const ctx = React.useContext(TimerContext);
  if (!ctx) {
    throw new Error("useCountdownTimer must be used inside <TimerProvider>");
  }
  return ctx;
}